import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { LucideX } from '@lucide/angular';

@Component({
  selector: 'app-x-icon-button',
  imports: [MatButtonModule, LucideX],
  templateUrl: './x-icon-button.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './x-icon-button.scss',
})
export class XIconButton {
  ariaLabel = input('Fermer');
  title = input('Fermer');
}
